<template>
	<div
		:class="[
			'main-container',
			'txt-center',
		]"
		:style="`border:0.1rem solid ${active ? globalColors.titulo : globalColors.border};color:${active ? globalColors.titulo : globalColors.border}`"
		v-bind="$attrs"
		@click="onClick"
	>
		<div class="d-flex align-center justify-center">
			<slot name="svg"></slot>
		</div>
		<span>{{text}}</span>
		<i
			:class="['el-icon-success']"
			:style="`color:${active ? globalColors.primary : globalColors.border}`"
		></i>
	</div>
</template>
<script>

function onClick() {
	if (!this.noClick) {
		this.active = !this.active;
		this.$emit('on-click');
	}
}

function value(newVal) {
	this.active = newVal;
}

function data() {
	return {
		active: !!this.value,
	};
}

export default {
	name: 'special-button',
	data,
	inheritAttrs: false,
	methods: {
		onClick,
	},
	props: {
		noClick: {
			default: false,
			type: Boolean,
		},
		text: {
			default: '',
			type: String,
		},
		value: null,
	},
	watch: {
		value,
	},
};
</script>
<style lang="scss" scoped>
	.main-container {
		align-items: center;
		border: 0.1rem solid color(borderGrey);
		border-radius: 0.4rem;
		color: color(borderGrey);
		cursor: pointer;
		display: grid;
		font-size: size(medium);
		height: 4.6rem;
		grid-column-gap: 0.5rem;
		grid-template-columns: 0.5fr 1.5fr 0.5fr;
	}

	span {
		white-space: pre-wrap;
	}
</style>



// WEBPACK FOOTER //
// specialButton.vue?04806262